<div [formGroup]="form" class="d-flex">
  <div class="col-sm-1 remove-btn-col">
    <button (click)="remove.emit(index)" class="remove-tax" type="button">
      <i class="fal fa-minus"></i>
    </button>
  </div>
  <div class="col-sm-3">
    <mat-form-field class="mat-block">
      <input
        type="text"
        formControlName="name"
        matInput
        [matAutocomplete]="auto"
        required
        placeholder="Tax Name:"
        i18n-placeholder
      />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let tax of filteredTaxes$ | async" [value]="tax.name">
          {{ tax.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
        Tax name is required
      </mat-error>
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')" i18n>
        Tax name must be at least 2 characters long
      </mat-error>
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')" i18n>
        Tax name must be at most 50 characters long
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-sm-3">
    <mat-form-field class="mat-block">
      <mat-label>
        <span [innerHtml]="form.get('type').value | amountPlaceholder : '$'"></span>
      </mat-label>
      <input type="number" min="0" formControlName="amount" required matInput decimal="4" />
      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
        Amount is required
      </mat-error>
      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('percent')">
        <ng-container i18n>Amount should be at least</ng-container> <b>0</b>
        <ng-container i18n>and less than</ng-container> <b>100</b>
      </mat-error>
      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('minNumber')" i18n>
        Amount must be at least 0
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-sm-2">
    <mat-form-field class="mat-block">
      <mat-select formControlName="type" placeholder="Type" i18n-placeholder>
        <mat-option value="percent" i18n>Percent</mat-option>
        <mat-option value="flat" i18n>Flat</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-sm-3">
    <mat-form-field class="mat-block">
      <mat-select formControlName="modality" placeholder="Modality" i18n-placeholder>
        <mat-option [value]="taxV3Modalities.PerStay">{{ taxV3ModalityLabels[taxV3Modalities.PerStay] }}</mat-option>
        <mat-option [value]="taxV3Modalities.PerNight">{{ taxV3ModalityLabels[taxV3Modalities.PerNight] }}</mat-option>
        <mat-option [value]="taxV3Modalities.PerPerson">{{
          taxV3ModalityLabels[taxV3Modalities.PerPerson]
        }}</mat-option>
        <mat-option [value]="taxV3Modalities.PerPersonPerNight">{{
          taxV3ModalityLabels[taxV3Modalities.PerPersonPerNight]
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
